import "globoid-js";
import Config from "../config";

const getClientId = (serviceId: string): string => {
  if (serviceId === Config.ALF_SERVICE_ID_INTERNATIONAL) {
    return Config.ALF_CLIENT_INTERNATIONAL;
  }
  return Config.ALF_CLIENT;
};

const InitOIDC = async (clientIdValue: string) => {
  window.glb.globoIdClientMap.initNewGloboIdClient({
    clientId: clientIdValue,
    resource: clientIdValue,
    url: `${Config.OIDC_URL}`,
    onLoad: "check-sso",
    redirectUri: `${Config.FE_BASE_URL}/sso.html`,
    legacyCompatible: Config.OIDC_LEGACY_COMPATIBLE,
    scope: "openid profile doc-number"
  });
};

const getServiceIdFromPage = (): string => {
  const providersMatch = window.location.pathname.match(
    /^\/providers\/[^/]+\/services\/([^/]+)/
  );
  if (providersMatch?.[1]) {
    return decodeURIComponent(providersMatch[1]);
  }

  const rootMatch = window.location.pathname.match(/^\/(\d+)$/);
  if (rootMatch?.[1]) {
    return decodeURIComponent(rootMatch[1]);
  }

  const queryServiceId = new URLSearchParams(window.location.search).get(
    "serviceId"
  );
  if (queryServiceId) {
    return queryServiceId;
  }

  return localStorage.getItem("serviceId") || "";
};

export const Authenticate = async (setUser: any) => {
  const serviceId = getServiceIdFromPage();
  const clientId = getClientId(serviceId);
  await InitOIDC(clientId);

  const globoIdClient = window.glb.globoIdClientMap.getGloboIdClient(clientId);

  globoIdClient.stageQueueMap.applicationUsageStageQueue =
    globoIdClient.stageQueueMap.applicationUsageStageQueue || [];

  globoIdClient.stageQueueMap.applicationUsageStageQueue.push(
    async (GloboId: any) => {
      const isLogged = await GloboId.isLogged();
      if (!isLogged) {
        await GloboId.loginCustomSettings({
          storeState: true
        });
      }

      const userData = await GloboId.loadUserInfo();
      if (!userData?.globo_id) {
        throw new Error("User not found");
      }

      localStorage.setItem("globoId", userData.globo_id);
      setUser({
        globoId: userData.globo_id,
        name: userData.name,
        email: userData.email,
        photo: userData.photoUrl
      });
    }
  );
};

export const Logout = (serviceId: string = getServiceIdFromPage()) => {
  const clientId = getClientId(serviceId);
  const globoIdClient = window.glb.globoIdClientMap.getGloboIdClient(clientId);
  globoIdClient.stageQueueMap.applicationUsageStageQueue.push(
    async (GloboId: any) => {
      await GloboId.logout();
    }
  );
};

export const GetOIDCToken = (serviceId: string = getServiceIdFromPage()) => {
  const clientId = getClientId(serviceId);
  const oidcValue = localStorage.getItem(`globoid-tokens-${clientId}`);
  if (oidcValue === null) {
    console.error("OIDC token not found");
    return "";
  }

  return JSON.parse(oidcValue).id_token;
};
